import apiClient from './client';

export const dashboardApi = {
  getSummary: async (params = {}) => {
    const { oem, start_date, end_date } = params;
    const queryParams = new URLSearchParams();
    
    if (oem) queryParams.append('oem', oem);
    if (start_date) queryParams.append('start_date', start_date);
    if (end_date) queryParams.append('end_date', end_date);
    
    const response = await apiClient.get(`/api/v1/dashboard/summary?${queryParams}`);
    return response.data;
  }
};
